/**
 * Vendor
 */
import React from 'react';

/**
 * CARIBE7 MODULES
 */
import BaseAlertService from '@shared/services/base/alerts/BaseAlertService';

/**
 * Info Alert Service
 *
 * @class      InfoAlertService (name)
 */
function InfoAlertService(component) {
  this.component   = component;
}

InfoAlertService.prototype = Object.assign(InfoAlertService.prototype, BaseAlertService.prototype);

/**
 * Registers Alert events, this follows naming convention
 *
 * @param      {Object}       self         The caller instance
 * @param      {BaseService}  service      The service
 * @param      {string}       module_name  The module name
 */
InfoAlertService.prototype.registerInfoAlertEvents = function(self, service) {
  var event_callback_map = {};
  event_callback_map[this.event_group.INFO_DISPLAY] = 'onInfoDisplay';
  event_callback_map[this.event_group.INFO_SUCCESS] = 'onInfoSuccess';
  event_callback_map[this.event_group.INFO_FAIL]    = 'onInfoFail';
  this.registerEvents(event_callback_map, service);
  return this;
}

/**
 * Removes Alert events.
 *
 * @param      {<type>}  self         The object
 * @param      {<type>}  service      The service
 * @param      {string}  module_name  The module name
 */
InfoAlertService.prototype.removeInfoAlertEvents = function() {
  this.removeEvents([
    this.event_group.INFO_DISPLAY,
    this.event_group.INFO_SUCCESS,
    this.event_group.INFO_FAIL
  ]);
  return this;
}

/**
 * Called when info alert display
 *
 * @param      {Object}  arg1       The argument 1
 * @param      {<type>}  arg1.data  The data
 */
InfoAlertService.prototype.onInfoDisplay = function({
  title='Info',
  message='',
  options={},
  onConfirm,
  onResolve,
  onError
}) {
  this.createSwal({
    props: {
      title:   <span>{title}</span>,
      html:    <span>{message}</span>,
      icon:    'info',
    },
    onConfirm: onConfirm,
    options: options,
    onResolve: onResolve,
    onError: onError,
  });
};

/**
 * Called on Regsiter success.
 *
 * @param      {object}  response  The response
 */
InfoAlertService.prototype.onInfoSuccess = function(response) {
  console.log("InfoAlertService::onInfoSuccess", response);
}

/**
 * Called on Regsiter fail.
 *
 * @param      {object}  error   The error
 */
InfoAlertService.prototype.onInfoFail = function(error) {
  console.log("InfoAlertService::onInfoFail", error);
}

export default InfoAlertService;